import { Button, Dropdown, MenuProps } from 'antd'
import styles from './MasterLayout.module.scss'
import { HomeOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom'
import { CREATE_MAGAZINE, HOME, LOGIN, SETTING_USER } from 'configs/path'
import { useAppDispatch, useAppSelector } from 'hooks'
import { logout } from '../../redux/slices/userSlice'
import { LayoutProps } from 'models/common'
import { roleType } from 'models/user'
import { deleteCookie } from 'utilities/helpers'
import { STORAGE_TOKEN_ADMIN } from 'configs/constant'

const MasterLayout = (props: LayoutProps) => {
  const { user } = useAppSelector((state) => state.user)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Link rel="noopener noreferrer" to={CREATE_MAGAZINE}>
          新規書籍（アプリ）作成
        </Link>
      )
    },
    {
      key: '2',
      label: (
        <Link rel="noopener noreferrer" to={SETTING_USER}>
          ユーザ管理
        </Link>
      )
    }
  ]

  const handleLogout = async () => {
    dispatch(logout())
    deleteCookie(STORAGE_TOKEN_ADMIN)
    navigate(LOGIN)
  }

  return (
    <div className={styles.masterLayout}>
      <div className={styles.masterLayout__header}>
        <p>ebookアプリ配信システム</p>
        <div className={styles.masterLayout__header__action}>
          <p className={styles.userId}>
            <span>ID:</span> {user.name}
          </p>
          <Link to={HOME} className={styles.home}>
            <HomeOutlined style={{ fontSize: '3rem' }} />
          </Link>

          {user?.role_id === roleType.ADMIN && (
            <Dropdown menu={{ items }} placement="bottom" arrow={{ pointAtCenter: true }}>
              <Button type="default" htmlType="submit" className="btn">
                設定
              </Button>
            </Dropdown>
          )}

          <Button type="default" htmlType="submit" className="btn" onClick={handleLogout}>
            ログアウト
          </Button>
        </div>
      </div>
      <section className={styles.container}>{props.children}</section>
    </div>
  )
}

export default MasterLayout
